var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4105 28.3072L23.6925 23.5892H10.6668C10.0182 23.5892 9.46284 23.3582 9.00084 22.8962C8.53884 22.4344 8.30784 21.8791 8.30784 21.2302V20.4098H22.8208C23.4835 20.4098 24.0508 20.1738 24.5228 19.7018C24.9948 19.2298 25.2308 18.6624 25.2308 17.9995V8.76884H26.0515C26.7002 8.76884 27.2555 8.99984 27.7175 9.46184C28.1795 9.92384 28.4105 10.4792 28.4105 11.1278V28.3072ZM5.58984 17.6305L7.47718 15.7432H20.1542C20.2737 15.7432 20.372 15.7047 20.4488 15.6278C20.5257 15.551 20.5642 15.4526 20.5642 15.3328V6.51251C20.5642 6.39273 20.5257 6.2944 20.4488 6.21751C20.372 6.14062 20.2737 6.10217 20.1542 6.10217H6.00018C5.88062 6.10217 5.78229 6.14062 5.70518 6.21751C5.62829 6.2944 5.58984 6.39273 5.58984 6.51251V17.6305ZM3.58984 22.4612V6.51251C3.58984 5.84962 3.82584 5.28217 4.29784 4.81017C4.76984 4.33817 5.33729 4.10217 6.00018 4.10217H20.1542C20.8168 4.10217 21.3842 4.33817 21.8562 4.81017C22.3282 5.28217 22.5642 5.84962 22.5642 6.51251V15.3328C22.5642 15.9957 22.3282 16.5632 21.8562 17.0352C21.3842 17.5072 20.8168 17.7432 20.1542 17.7432H8.30784L3.58984 22.4612Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.beb52ad22029cd3834dc0b80df642484.svg";
export { ForwardRef as ReactComponent };